import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatAnchor } from '@angular/material/button';

@Component({
  selector: 'app-login-failed',
  standalone: true,
  imports: [MatIcon, MatAnchor],
  templateUrl: './login-failed.component.html',
  styleUrl: './login-failed.component.scss'
})
export class LoginFailedComponent {}
